export default __webpack_public_path__ + "static/media/planateers.5f7d57f5.png";